// #608 — a pure helper of `components/ring/FitText.tsx`, apart from React so
// that a static test can import it.

/** Two lines of a text, broken after a hyphen or at a space: the break that
 *  makes the longer of the two lines as short as possible. A double last name
 *  breaks at its hyphen
 *  ("Stankevičiūtė-" / "Kazlauskienė"). Null when the text has no break. */
export function twoLines(text: string): [string, string] | null {
  const t = text.trim();
  let best: [string, string] | null = null;
  for (let i = 1; i < t.length; i++) {
    const afterHyphen = t[i - 1] === '-';
    if (!afterHyphen && t[i] !== ' ') continue;
    const first = t.slice(0, i).trim();
    const second = t.slice(afterHyphen ? i : i + 1).trim();
    if (!first || !second) continue;
    if (!best || Math.max(first.length, second.length) < Math.max(best[0].length, best[1].length)) best = [first, second];
  }
  return best;
}
